export interface QueueOrderSearchRequest {
  page: number;
  pageSize: number;
  searchParameters?: {
    orderNumbers?: string[];
    statuses?: QueueOrderSearchStatus[];
    actionDate?: string; // ISO date string
    hasNoActionDate?: boolean; // Filter for orders with null action date
    filterSearch?: string;
  };
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}

export enum QueueOrderSearchStatus {
  All = 0,
  Pending = 1,
  InProgress = 2,
  Done = 3,
  Scheduled = 4
}
